import ApiBase from '../api-base'
import {ACTIVE_BASE_REST} from '../constants'
export default class CmsSplash extends ApiBase {
    constructor (store) {
        const path = ACTIVE_BASE_REST + '/cms/splash'
        super(store, path)
    }
}